import { graphql } from "@repo/graphql-types";
import { Right, StoreV2 } from "@repo/icons";
import { Link, useRouteContext } from "@tanstack/react-router";
import {
  SectionHeaderButton,
  SectionHeaderContent,
  SectionHeaderDescription,
  SectionHeaderIcon,
  SectionHeaderInfo,
  SectionHeaderRoot,
  SectionHeaderTitle,
} from "@/components/section-header";
import { useGraphQL } from "@/hooks/use-graphql";
import { HomeSectionOneLivEmptyState } from "@/components/home/home-section-oneliv-empty-state";
import { HomeSectionOneLivActive } from "@/components/home/home-section-oneliv-active";
import { AsyncDataWrapper } from "@/components/async-data-wrapper";
import { Skeleton } from "@/components/skeleton.tsx";
import { ErrorCard } from "@/components/home/error-card.tsx";

export const HomeSectionOneLivQuery = graphql(/* GraphQL */ `
  query HomeSectionOneLivQuery($codUsuario: Int!) {
    locus_membro(where: { codUsuario: { _eq: $codUsuario } }) {
      ativo
    }
    locus_conselho_profissional(where: { ativo: { _eq: true } }) {
      sigla
    }
    ...HomeSectionOneLivActiveFragment
  }
`);

export const HomeSectionOneLiv = (): JSX.Element | null => {
  const { user } = useRouteContext({ strict: false });
  const queryResult = useGraphQL(HomeSectionOneLivQuery, {
    codUsuario: user.codUsuario,
  });

  const { data, refetch } = queryResult;
  const refetchOnelivQuery = (): void => {
    void refetch();
  };
  const isProfileCreated = Boolean((data?.locus_membro.length ?? 0) > 0);

  const fallback = <Skeleton className="rounded-lg h-[11.75rem]" />;

  const shouldDisplayOneLivSection = (): boolean => {
    const allowedProfessionalCouncils = data?.locus_conselho_profissional ?? [];

    return allowedProfessionalCouncils
      .map((item) => item.sigla)
      .includes(user.codConselhoClasse ?? "");
  };

  if (!shouldDisplayOneLivSection()) {
    return null;
  }

  return (
    <div className="gap-4 flex flex-col">
      <SectionHeaderRoot>
        <SectionHeaderContent>
          <SectionHeaderIcon className="bg-white">
            <StoreV2 size={16} className="fill-primary-400" />
          </SectionHeaderIcon>
          <SectionHeaderInfo>
            <SectionHeaderTitle>Oneliv</SectionHeaderTitle>
            <SectionHeaderDescription>
              Plataforma de agendamentos de consultas
            </SectionHeaderDescription>
          </SectionHeaderInfo>
        </SectionHeaderContent>
        {isProfileCreated && data ? (
          <Link to="/oneliv/welcome">
            <SectionHeaderButton>
              Editar <Right size={16} />
            </SectionHeaderButton>
          </Link>
        ) : (
          <div />
        )}
      </SectionHeaderRoot>

      <AsyncDataWrapper
        {...queryResult}
        errorFallback={<ErrorCard onClick={refetchOnelivQuery} />}
        fallback={fallback}
      >
        <div>
          {isProfileCreated && data ? (
            <HomeSectionOneLivActive data={data} />
          ) : (
            <HomeSectionOneLivEmptyState />
          )}
        </div>
      </AsyncDataWrapper>
    </div>
  );
};
